/* eslint-disable */


import PropTypes from 'prop-types';
// @mui
import { Box, Chip, Stack, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// utils
import { fDate } from '../../../utils/formatTime';
// components
import { ServerUtils } from '../../../api_utils';
import Image from '../../../components/Image';
import UserAvatar from '../../../components/UserAvatar';

// ----------------------------------------------------------------------

const OverlayStyle = styled('h1')(({ theme }) => ({
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  zIndex: 9,
  position: 'absolute',
  backgroundColor: alpha(theme.palette.grey[900], 0.72),
}));

const TitleStyle = styled('h1')(({ theme }) => ({
  ...theme.typography.h1,
  top: 0,
  zIndex: 10,
  width: '100%',
  textAlign: 'center',
  color: theme.palette.common.white,
  [theme.breakpoints.up('lg')]: {
    textAlign: 'start',
  },
}));

const SubtitleStyle = styled('h4')(({ theme }) => ({
  ...theme.typography.h4,
  top: 0,
  zIndex: 10,
  width: '100%',
  textAlign: 'center',
  color: theme.palette.grey[400],
  [theme.breakpoints.up('lg')]: {
    textAlign: 'start',
  },
}));

const FooterStyle = styled('div')(({ theme }) => ({
  bottom: 0,
  zIndex: 10,
  width: '100%',
  display: 'flex',
  position: 'absolute',
  alignItems: 'flex-end',
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(2),
  paddingBottom: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('sm')]: {
    alignItems: 'center',
    paddingRight: theme.spacing(3),
  },
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(10),
  },
}));

// ----------------------------------------------------------------------

BlogPostHero.propTypes = {
  post: PropTypes.object.isRequired,
};

export default function BlogPostHero({ post }) {
  const { imageUrl, title, subtitle, poster, tags, created_at } = post;

  const isDesktop = useResponsive('up', 'sm');

  return (
    <Box sx={{ position: 'relative', height: '100%' }}>
      <Stack sx={{ pt: { xs: 16, md: 16 }, px: { sx: 3, md: 10 }, position: 'absolute', width: '100%' }} spacing={1}>
        <TitleStyle>{title}</TitleStyle>
        <SubtitleStyle>{subtitle}</SubtitleStyle>

        <Stack direction="row" sx={{ justifyContent: { xs: "center", md: "start" } }}>
          {tags.map((tag) => (
            <Chip color='primary' key={tag} label={tag} sx={{ m: 0.5, zIndex: 12 }} />
          ))}
        </Stack>
      </Stack>

      <FooterStyle>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <UserAvatar user={poster} sx={{ width: 48, height: 48 }} />
          <Box sx={{ ml: 2 }}>
            <Typography variant="subtitle1" sx={{ color: 'common.white' }}>
              {poster.name}
            </Typography>
            <Typography variant="body2" sx={{ color: 'grey.500' }}>
              {fDate(created_at)}
            </Typography>
          </Box>
        </Box>

        {/* 
        <SpeedDial
          direction={isDesktop ? 'left' : 'up'}
          ariaLabel="Share post"
          icon={<Iconify icon="eva:share-fill" sx={{ width: 20, height: 20 }} />}
          sx={{ '& .MuiSpeedDial-fab': { width: 48, height: 48 } }}
        >
          {SOCIALS.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              tooltipPlacement="top"
              FabProps={{ color: 'default' }}
            />
          ))}
        </SpeedDial> 
        */}
      </FooterStyle>

      <OverlayStyle />
      <Image alt="post cover" src={ServerUtils.getPostImageUrl(post)} sx={{ height: 500 }} />
    </Box>
  );
}
